/* import __COLOCATED_TEMPLATE__ from './activation-resent.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();